import { BHS_PRETO, BHS_VERDE } from 'constants/cores';

export default {
    token: {
        // Seed Token
        itemMarginBottom: 0,
        colorPrimary: BHS_VERDE,
        colorText: BHS_PRETO
        // Alias Token
    },
    components: {
        Radio: {
            buttonColor: BHS_PRETO,
            radioSize: 20
        },
        // Etapa ativa em grafite em vez do verde da marca: nos indicadores de etapa o verde
        // já significa "concluído", e as duas cores lado a lado ficam indistinguíveis.
        Steps: {
            colorPrimary: BHS_PRETO
        },
      },
};
